import type { ReactElement } from 'react';
import { Button } from '../../button';

export interface ChipProps {
    id: string;
    isActive?: boolean;
    onClick: (productId?: string) => void;
    children: React.ReactNode | React.ReactNode[];
    value?: string | number | readonly string[];
    size?: 'small' | 'default';
    testId?: string;
}
export const Chip = ({
    id,
    testId,
    isActive = false,
    onClick,
    children,
    value,
    size = 'default',
}: ChipProps): ReactElement => (
    <Button
        id={testId}
        isActive={isActive}
        variant="chip"
        value={value}
        onClick={() => onClick(id)}
        textSize="small"
        minWidth={size === 'default' ? undefined : '44px'}
    >
        {children}
    </Button>
);

Chip.defaultProps = {
    isActive: false,
    value: undefined,
    size: 'default',
    testId: undefined,
};
